<template>
  <main>
    <div class="pt-96p lg:pb-96p">
      <div class="flex flex-col gap-12 justify-center items-center h-265p shadow-4xl z-20 mb-20 bg-navy text-white" data-aos="fade-up">
        <h1 class="text-32 font-bold tracking-wider">
          {{ page.title }}
        </h1>

        <div class="text-neutral/500 font-bold">
          {{ page.sub_title }}
        </div>
      </div>
    </div>

    <section class="max-w-content m-auto pb-96p px-8 sm:px-16">
      <p class="leading-6 text-neutral/500 whitespace-pre-line">{{ page.description }}</p>

      <div v-for="section in sections" :key="section.id || section.title" data-aos="fade-up">
        <h2 class="mt-43p font-bold text-blue_500">{{ section.title }}</h2>
        <p class="mt-3 text-neutral/500 leading-6 whitespace-pre-line">{{ section.description }}</p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'TermsAndConditions',
}
</script>

<script setup>
import { computed } from 'vue'
import { useContent } from '@/composables/useContent'

const defaultPage = {
  title: 'Terms and Conditions',
  sub_title: 'Updated 28/10/2022',
  description: 'Welcome to our website. If you continue to browse and use this website, you are agreeing to comply with and be bound by the following terms and conditions of use.',
}

const { items: pages } = useContent('termsPage', [defaultPage])
const { items: sections } = useContent('termsItem', [])

const page = computed(() => pages.value[0] ?? defaultPage)
</script>
